export default "__VITE_ASSET__CjjkgSmP__"